<ng-container
  *ngrxLet="{
    companyUserList: companyUserList$,
    currentUserId: currentUserId$,
  } as vm">
  <ninety-card class="ninety-card">
    <ninety-card-header header>
      <div class="terra-title">Add Helpful to New Company</div>
      <terra-form-field>
        <terra-text-input
          [formControl]="companyToFindForm"
          placeholder="Enter company ID"
          (keydown.enter)="findCompanyById()">
          <terra-input-prefix class="search-icon">
            <terra-icon icon="search" />
          </terra-input-prefix>
        </terra-text-input>
        @if (companyToFindForm.errors?.isObjectId) {
          <terra-error>Please enter a valid object id</terra-error>
        }
      </terra-form-field>
    </ninety-card-header>

    @if (foundCompany) {
      <div class="card-content">
        <div class="found-company">
          @if (foundCompany.logoUrl) {
            <img [src]="foundCompany.logoUrl" alt="company logo" class="company-logo" loading="lazy" />
          }
          <div class="flex1">
            {{ foundCompany.companyName }}
          </div>
          @if (alreadyInCompany) {
            <ninety-alert alertClass="warning"> Helpful is already in this company </ninety-alert>
          }
          @if (!alreadyInCompany) {
            @if (!newCompanyUser) {
              <ninety-button filled primary class="uppercase" (click)="addHelpful()">
                <terra-icon icon="add" />
                Add Helpful to this Company
              </ninety-button>
            }
            @if (newCompanyUser) {
              <ninety-button filled primary class="uppercase" (click)="switchCompany(newCompanyUser)">
                <terra-icon icon="sign-in" />
                Login
              </ninety-button>
            }
          }
        </div>
      </div>
    }
  </ninety-card>

  <ninety-card class="ninety-card">
    <ninety-card-header header>
      <div class="terra-title">Helpful Companies</div>
      <terra-search-input
        [class.hidden]="vm.companyUserList?.length <= 10"
        [formControl]="companyFilterSearch"
        placeholder="Search current companies by name or ID"
        (keyup.enter)="findCompanyById()" />
    </ninety-card-header>

    <div class="card-content">
      <mat-list class="ninety-list">
        @for (c of vm.companyUserList | searchCompanyFilter: companyFilterSearch.value; track c.userId) {
          <mat-list-item>
            <div matListItemLine class="list-item">
              <div class="company-name">
                {{ c.companyName }}
              </div>
              @if (c?.logoUrl) {
                <img [src]="c?.logoUrl" alt="company logo" class="company-logo" loading="lazy" />
              }
              <ninety-button
                flat
                primary
                (click)="switchCompany(c)"
                [disabled]="c.userId === vm.currentUserId"
                ninetyTooltip="Login to this company">
                <terra-icon icon="sign-in" />
                Login
              </ninety-button>
              <ninety-button
                flat
                icon
                negative
                class="delete-btn"
                (click)="removeHelpfulFromCompany(c)"
                [disabled]="c.userId === vm.currentUserId"
                ninetyTooltip="Remove Helpful from this company">
                <terra-icon icon="delete" />
              </ninety-button>
            </div>
          </mat-list-item>
        }
      </mat-list>
    </div>
  </ninety-card>
</ng-container>
